import Chip from '@mui/material/Chip';

// Coloured pill badge used across cards and report lists
const TONES = {
  sage: { bg: '#C8EDD8', color: '#152A1E' },
  amber: { bg: '#FEF3C7', color: '#92400E' },
  green: { bg: '#D1FAE5', color: '#065F46' },
  red: { bg: '#FEE2E2', color: '#991B1B' },
  forest: { bg: '#152A1E', color: '#fff' },
  violet: { bg: '#EDE9FE', color: '#553C9A' },
  stone: { bg: '#F4EFE5', color: '#6B6B65' },
};

const StatusBadge = ({ tone = 'sage', children, sx = {}, ...rest }) => {
  const t = TONES[tone] || TONES.sage;
  return (
    <Chip
      label={children}
      size="small"
      sx={{
        bgcolor: t.bg,
        color: t.color,
        fontWeight: 700,
        fontSize: 11,
        letterSpacing: '0.04em',
        height: 24,
        ...sx,
      }}
      {...rest}
    />
  );
};

export default StatusBadge;
